import Th from "@/components/Table/Th";
import { table_head } from "../../maintainers.module.scss";

import { table_titles, table_titles_with_sector } from "./business_center.constants";

const BusinessCenterTableHead = ({ useSectors, order, setOrder, orderType, setOrderType }) => {
	const titles = useSectors ? table_titles_with_sector : table_titles;

	return (
		<thead className={table_head}>
			<tr>
				{titles &&
					titles.map((title, i) => {
						return (
							<Th
								key={i}
								item_name={title.name}
								item_size={title.size}
								item_order={title.order}
								order={order}
								setOrder={setOrder}
								orderType={orderType}
								setOrderType={setOrderType}
								item_class={title.class}
								only_admin={title.only_admin}
								border_color={"0.5px solid #7fb02f"}
							></Th>
						);
					})}
			</tr>
		</thead>
	);
};

export default BusinessCenterTableHead;
